import { buttonLibraryService } from "@Shared/Service/ButtonLibraryService";
import { cardsLibraryService } from "@Shared/Service/CardsLibraryService";
import { panelLibraryService } from "@Shared/Service/PanelLibraryService";
import { useEffect } from "react";

export const useFetchLibraryMacros = ({ setters = {} }) => {
  const { setLibraryButtons, setLibraryPanels, setLibraryCards } = setters;

  useEffect(() => {
    if (setLibraryButtons) {
      buttonLibraryService
        .getAllButtons()
        .then((res) => setLibraryButtons(res?.data || []))
        .catch(() => console.log("Failed to get saved buttons."));
    }
  }, [setLibraryButtons]);

  useEffect(() => {
    if (setLibraryPanels) {
      panelLibraryService
        .getAllPanels()
        .then((res) => {
          setLibraryPanels(res?.data || []);
        })
        .catch(() => console.log("Failed to get saved panels"));
    }
  }, [setLibraryPanels]);

  useEffect(() => {
    if (setLibraryCards) {
      cardsLibraryService
        .getAllCards()
        .then((res) => setLibraryCards(res?.data || []))
        .catch(() => console.log("Failed to get saved cards."));
    }
  }, [setLibraryCards]);
};
